<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" selector :view-config="auth('b_leave_application_viewmanage')">
                <template #search>
                    <m-search ref="search" :default-data="defaultSearchData">
                        <m-search-item label="单据编号">
                            <c-input name="document_number"></c-input>
                        </m-search-item>
                        <m-search-item label="申请人">
                            <c-input name="user_realname"></c-input>
                        </m-search-item>
                        <m-search-item label="状态">
                            <c-select name="status" multiple :options="applyStatusDic" clearable></c-select>
                        </m-search-item>
                        <m-search-item label="请假类型">
                            <c-select name="leave_type" :options="leaveTypeDic" clearable></c-select>
                        </m-search-item>
                    </m-search>
                </template>
                <!--单据编号-->
                <template #document_number="{data}">
                    <c-link @click="globalDialog('leaveApplicationDetail', {props: {id: data.id}})">{{data.document_number}}</c-link>
                </template>
                <template #status="{data}">
                    <c-state dict="applyStatusDic"  :value="data.status"></c-state>
                </template>
                <template #emergency_level="{data}">
                    <c-state dict="urgencyLevelDic" tag :value="data.emergency_level"></c-state>
                </template>
                <template #leave_type="{data}">
                    <c-state dict="leaveTypeDic" :value="data.leave_type"></c-state>
                </template>
                <template #start_date="{data}">
                    <template v-if="data.leave_granularity == 1">{{data.start_time||data.start_date}}</template>
                    <template v-if="data.leave_granularity == 2">{{data.start_time}}</template>
                </template>
                <template #end_date="{data}">
                    <template v-if="data.leave_granularity == 1">{{data.end_time||data.end_date}}</template>
                    <template v-if="data.leave_granularity == 2">{{data.end_time}}</template>
                </template>
                <template #leave_duration="{data}">
                    <template v-if="data.leave_granularity == 1">{{data.leave_duration}}天</template>
                    <template v-if="data.leave_granularity == 2">{{data.leave_duration}}小时</template>
                </template>

                <template #operate="{data}">
                    <c-button color="main" v-if="auth('b_leave_application_edit')" prepend-icon="tf-add" @click="$refs.leaveEdit.open()">发起请假</c-button>
                    <c-button v-if="auth('b_leave_application_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                    <c-button color="main" prepend-icon="tf-success" @click="batchApprove(data, 1)">批量通过</c-button>
                    <c-button prepend-icon="tf-reject" @click="batchApprove(data, 9)">批量驳回</c-button>
                </template>
                <template #batchOperate="{data}">
                    <c-button color="main" prepend-icon="tf-success" @click="batchApprove(data, 1)">批量通过</c-button>
                    <c-button prepend-icon="tf-reject" @click="batchApprove(data, 9)">批量驳回</c-button>
                </template>
                <c-table-column
                        type="button"
                        label="操作"
                        width="220"
                        button-limit="3"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_leave_application_view')" icon="tf-view" @click="globalDialog('leaveApplicationDetail', {props: {id: data.id}})">查看</c-table-button>
                        <c-table-button v-if="auth('b_leave_application_edit') && data.is_founder==1" :disabled="!(data.status == -1)" icon="tf-edit" @click="$refs.leaveEdit.open(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_leave_application_edit') && data.is_founder==1" :disabled="!(data.status == -1)" icon="tf-delete" @click="removeLeaveApplication(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <leave-application-edit ref="leaveEdit" @resolve="$refs.view.$refs.list.update()"></leave-application-edit>
            <!--批量驳回弹窗-->
            <c-dialog ref="rejectDialog" title="批量驳回" width="500" height="200" @resolve="batchRejectHandle">
                <c-form ref="rejectForm" vertical unit-width="100%">
                    <c-form-item label="驳回原因">
                        <c-input name="remark" type="textarea" :rows="3" placeholder="请输入驳回原因"></c-input>
                    </c-form-item>
                </c-form>
            </c-dialog>
        </module>
    </page>
</template>

<script>
import LeaveApplicationEdit from "@/pages/basic/leave_application_edit.vue";
import {mapState} from "vuex";

export default {
    components: {
        LeaveApplicationEdit,
    },
    computed: {
        ...mapState(['urgencyLevelDic', 'leaveTypeDic', 'applyStatusDic','timePeriodDic']),
    },
    data() {
        return {
            workType: 12,
            defaultSearchData: {
                'status': []
            }
        }
    },

    mounted() {
        this.$bus.$on('leave_application_list.update', data => {
            // 刷新列表
            this.$refs.view.$refs.list.refresh();
            // 刷新二级分组数量
            this.$refs.view.updateTabTotal && this.$refs.view.updateTabTotal();
        });
        this.$bus.$on('leave_application_list.edit', data => {
            this.$refs.leaveEdit.open(data);
        });
    },

    methods: {
        batchApprove(data, executeState) {
            if (!data || !data.length) {
                this.$message({message: '请至少选择一条数据'});
                return;
            }
            let invalidList = data.filter(item => item.status != 1);
            if (invalidList.length) {
                let nums = invalidList.map(item => item.document_number || item.id).join('、');
                this.$message({message: '以下单据非审批中状态，无法操作：' + nums, type: 'warning'});
                return;
            }
            let orderIds = data.map(item => item.id);
            if (executeState == 1) {
                this.$confirm({
                    message: '确定要批量通过选中的 ' + data.length + ' 条请假申请吗？',
                    buttonName: '确定',
                    cancelButton: true,
                    resolve: () => {
                        this.request({
                            url: '/workflow/order/batch/approve',
                            data: {
                                order_type: 4,
                                execute_state: executeState,
                                order_ids: orderIds
                            },
                            loading: true,
                            success: (data, msg) => {
                                let message = msg || '批量审批成功';
                                if (data && data.fail_list && data.fail_list.length) {
                                    let details = data.fail_list.map(item => item.reason).join('；');
                                    message += '\n' + details;
                                }
                                this.$message({message: message, type: data && data.fail_count ? 'warning' : 'success'});
                                this.$refs.view.batchCancelHandle();
                                setTimeout(() => {
                                    this.$refs.view.$refs.list.update();
                                    this.$refs.view.updateTabTotal && this.$refs.view.updateTabTotal();
                                }, 2000);
                            }
                        });
                    },
                    cancel: () => {},
                });
            } else {
                this._batchOrderIds = orderIds;
                this.$refs.rejectForm.clear();
                this.$refs.rejectDialog.open();
            }
        },

        batchRejectHandle(stop) {
            stop();
            this.$refs.rejectForm.validate({
                rule: {
                    remark: '请输入驳回原因'
                },
                success: formData => {
                    this.request({
                        url: '/workflow/order/batch/approve',
                        data: {
                            order_type: 4,
                            execute_state: 9,
                            order_ids: this._batchOrderIds,
                            remark: formData.remark
                        },
                        loading: true,
                        success: (data, msg) => {
                            let message = msg || '批量驳回成功';
                            if (data && data.fail_list && data.fail_list.length) {
                                let details = data.fail_list.map(item => item.reason).join('；');
                                message += '\n' + details;
                            }
                            this.$message({message: message, type: data && data.fail_count ? 'warning' : 'success'});
                            this.$refs.rejectDialog.close();
                            this.$refs.view.batchCancelHandle();
                            setTimeout(() => {
                                this.$refs.view.$refs.list.update();
                                this.$refs.view.updateTabTotal && this.$refs.view.updateTabTotal();
                            }, 2000);
                        }
                    });
                }
            });
        },

        removeLeaveApplication(data) {
            this.$confirm({
                message: '确认删除请假单【' + (data.document_number || data.id) + '】？删除后不可恢复',
                buttonName: '确定',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/leave/application/delete',
                        data: {id: data.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.$refs.view.$refs.list.update();
                        }
                    });
                },
                cancel: () => {},
            });
        },
    },
}
</script>

<style lang="stylus" scoped>
</style>
